module.exports = {
      id: "logo-usage",
      viewBox: "0 0 123 19",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#logo",
      toString: function () {
        return this.url;
      }
    }